var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncentiveSchemeImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33293 24.3359H61.0006C62.8401 24.3359 64.3335 25.8293 64.3335 27.6689V37.6716C64.3335 39.5111 62.8401 41.0045 61.0006 41.0045H4.33293C2.48951 41.0045 1 39.5111 1 37.6716V27.6689C1 25.8293 2.48951 24.3359 4.33293 24.3359Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6672 42.5059V69.5077",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6655 40.998V70.9983H57.6673V40.998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9999 24.3358C27.2975 23.2197 24.3496 21.8857 22.1601 20.3301C17.1315 16.7638 16.4159 11.4552 19.5466 8.799C22.1601 6.57834 26.3058 7.29004 29.0709 13.9909C29.8721 15.9277 30.5138 19.3773 30.9999 24.3358Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9999 24.3359C36.5535 22.7725 40.9753 20.9018 44.2577 18.7278C51.8025 13.7343 52.8759 6.30615 48.1779 2.58431C44.2577 -0.526944 38.0391 0.472548 33.8933 9.85299C32.6916 12.5676 31.7271 17.3939 30.9999 24.3359Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 52,
    r: 24,
    fill: "#F8DED0",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48C57 48 57.7292 49.5301 59.9885 49.5301C62.2478 49.5301 62.7916 48 62.7916 48",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2253 48C76.2253 48 76.9545 49.5301 79.2138 49.5301C81.4731 49.5301 82 48 82 48",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3349 59.7736C76.3349 59.7736 74.9439 56.3594 69.7171 56.3594C64.4903 56.3594 63.2173 59.7736 63.2173 59.7736",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentiveSchemeImg);
export default __webpack_public_path__ + "static/media/incentive_scheme_img.e91b5d0fea442960cdeb7badda087117.svg";
export { ForwardRef as ReactComponent };